import { gql } from 'apollo-boost';

export const freelancerFeedbackFragment = gql`
    fragment FreelancerFeedbackQueryFragment on GdFreelancerFeedback {
        authorInfo {
            avatarUrl
            login
            name
            userId
        }
        authorUid
        createdTime
        feedbackId
        feedbackText
        freelancerId
        overallMark
        willRecommend
        moderationStatus
    }
`;

export const freelancerContactsFragment = gql`
    fragment FreelancerContactsFragment on GdFreelancerContacts {
        siteUrl
        whatsApp
        phone
        icq
        telegram
        email
        viber
        skype
    }
`;

export const freelancerServiceFragment = gql`
    fragment FreelancerServiceFragment on GdFreelancerSkillType {
        name
        skillCode
        skillId
    }
`;

export const freelancerPrivateDataFragment = gql`
    fragment FreelancerPrivateDataFragment on GdFreelancerPrivateData {
        freelancerId
        newestCard {
            statusModerate
            briefInfo
            avatarUrl
            contacts {
                ...FreelancerContactsFragment
            }
        }
        advQuality {
            advQualityRank
            advQualityRating
        }
    }
    ${freelancerContactsFragment}
`;

export const freelancersListUpdateQuery = gql`
    query FreelancersListUpdateQuery($login: String!) {
        freelancersList(filter: { logins: [$login] }) {
            privateData {
                ...FreelancerPrivateDataFragment
            }
        }
        reqId: getReqId
        client(searchBy: { login: $login }) {
            freelancerProjects(filter: { isActive: true }) {
                freelancerId
            }
        }
    }
    ${freelancerPrivateDataFragment}
`;

export const freelancerRegisteredQuery = gql`
    query FreelancerRegisteredQuery(
        $freelancerLogin: String!
        $login: String!
    ) {
        freelancersList(filter: { logins: [$freelancerLogin] }) {
            privateData {
                ...FreelancerPrivateDataFragment
            }
            fio
            login
            card {
                avatarUrl
            }
            feedbacks {
                ...FreelancerFeedbackQueryFragment
            }
        }
        reqId: getReqId
        constants {
            freelancersCount
        }
        client(searchBy: { login: $login }) {
            info {
                id
                chiefUser {
                    name
                    avatarUrl
                    phone
                }
            }
            freelancerProjects(filter: { isActive: true }) {
                id
                freelancerId
                createdTime
                startedTime
                status
                freelancer {
                    login
                }
            }
            hasCooperation: freelancerProjects(
                filter: {
                    freelancerLogin: $freelancerLogin
                    isStarted: true
                    first: 1
                }
            ) {
                id
            }
            access {
                canRequestFlService
            }
        }
        constants {
            freelancersCount
        }
    }
    ${freelancerPrivateDataFragment}
    ${freelancerFeedbackFragment}
`;

export const freelancerCustomersQuery = gql`
    query FreelancerCustomersQuery($login: String!) {
        reqId: getReqId
        freelancersList(filter: { logins: [$login] }) {
            privateData {
                freelancerId
                projects {
                    id
                    status
                    createdTime
                    updatedTime
                    startedTime
                    client {
                        fio
                        clientId
                        chiefLogin
                        phoneNumber
                    }
                }
            }
        }
    }
`;

export const clientFreelancerQuery = gql`
    query ClientFreelancerQuery($login: String!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            chiefLogin
            freelancerProjects(filter: { isActive: true }) {
                freelancer {
                    login
                    fio
                    card {
                        contacts {
                            phone
                        }
                        avatarUrl
                    }
                }
                status
            }
            info {
                id
                chiefUser {
                    phone
                    avatarUrl
                    name
                }
            }
        }
    }
`;

export const freelancerEditorQuery = gql`
    query FreelancerEditorQuery(
        $freelancerLogin: String!
        $lang: GdLanguageInput!
    ) {
        reqId: getReqId
        constants {
            freelancerSkillTypes {
                ...FreelancerServiceFragment
            }
        }
        freelancersList(filter: { logins: [$freelancerLogin] }) {
            fio
            login
            createTime
            certificates {
                certId
                type
                link
            }
            skills {
                name
                skillId
                days
                price
                duration
            }
            privateData {
                freelancerId
                newestCard {
                    briefInfo
                    avatarUrl
                    contacts {
                        ...FreelancerContactsFragment
                    }
                }
            }
            card {
                briefInfo
                avatarUrl
                contacts {
                    ...FreelancerContactsFragment
                }
            }
            region(lang: $lang) {
                regionId
                translation {
                    region
                    country
                }
            }
        }
    }
    ${freelancerServiceFragment}
    ${freelancerContactsFragment}
`;
